/** @format */

import React, { Component } from 'react'
import { BrowserRouter, HashRouter, Route, Switch } from 'react-router-dom'
import { Layout } from 'antd'
import Login from './page/manager_login';
import Inspiration from './route/inspiration';
import Case from './route/case';
import './App.css';
import ClassifyAudit4Old_Old from './page/inspiration/classifyAudit4Old/old'

const { Content } = Layout

class App extends Component {

  state = {
    collapsed: true,
    contentLeft: 80, //内容距离左侧距离
  }

  componentDidMount() {

  }


  render() {
    return (
      <HashRouter basename={window.__POWERED_BY_QIANKUN__ ? '/manager-linggan' : '/'}>
        <Layout>
          <Layout style={{ marginLeft: 0 }}>
            <Content style={{ margin: '10px 16px 0', overflow: 'initial' }}>
              <Switch>
                <Route path={"/inspiration"} component={Inspiration}></Route>
                <Route path={"/case"} component={Case}></Route>
                <Route exact path="/" component={Login} />
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </HashRouter>
    )
  }
}

export default App
